import Transformer from './transformer'
import * as d3 from 'd3-selection'

/*
 * This transformer is used when the map's `deemphasize` settings have changed.
 * ie. when a user hovers in/out of a legend.
 */
class NoopDeemphasize extends Transformer {

  static match (d0, d1, opts) {
    if (d0) {
      return false // Nodes are leaving, not a match
    }
    return opts.deemphasizeChanged
  }

  constructor (enter, exit, opts) {
    super(enter, exit, opts)

    let svg = opts.chart.node().ownerSVGElement

    // This update is fast (i.e. not a 1500ms animation_),
    // we're just updating the opacity of map nodes
    // Remove the `is-updating` class on the svg in case the user hovers off
    // the legend quickly.
    d3.select(svg).classed('is-updating', false)
  }

  transform () {
    // no-op
  }

}

export default NoopDeemphasize
